const ALL = 'ALL';
const CLOSED = 'CLOSED';
const OPEN = 'OPEN';

export const statusTypes = {
  CLOSED,
  OPEN,
  ALL,
};

export const statusTypesLabels = {
  [CLOSED]: 'reports:statusTypes.CLOSED',
  [OPEN]: 'reports:statusTypes.OPEN',
};

export const statusTypesVariants = {
  [CLOSED]: 'closed',
  [OPEN]: 'success',
};

export const statusTypesOptions = [
  { label: statusTypesLabels[OPEN], value: statusTypes.OPEN },
  { label: statusTypesLabels[CLOSED], value: statusTypes.CLOSED },
  { label: 'common:forms.allViews', value: statusTypes.ALL },
];

const PAID = 'Pagada';
const UNPAID = 'Sin pagar';

export const statusTipTypes = {
  PAID,
  UNPAID,
};

export const statusTipTypesLabels = {
  [PAID]: 'reports:statusTipTypes.PAID',
  [UNPAID]: 'reports:statusTipTypes.UNPAID',
};

export const statusTipTypesVariants = {
  [PAID]: 'success',
  [UNPAID]: 'closed',
};

const CLOSED_CASHIER = 'Abierta';
const OPEN_CASHIER = 'Cerrada';

export const statusCashierTypes = {
  CLOSED_CASHIER,
  OPEN_CASHIER,
};

export const statusCashierTypesLabels = {
  [CLOSED_CASHIER]: 'reports:statusTypes.CLOSED_CASHIER',
  [OPEN_CASHIER]: 'reports:statusTypes.OPEN_CASHIER',
};

export const statusCashierTypesVariants = {
  [CLOSED_CASHIER]: 'success',
  [OPEN_CASHIER]: 'closed',
  OPEN: 'success',
  CLOSED: 'closed',
};

export const statusCashierTypesOptions = [
  { label: statusCashierTypesLabels[OPEN_CASHIER], value: statusCashierTypes.OPEN_CASHIER },
  { label: statusCashierTypesLabels[CLOSED_CASHIER], value: statusCashierTypes.CLOSED_CASHIER },
  { label: 'common:forms.allViews', value: '' },
];
